import { useState } from "react";
import { Link } from "react-router-dom";

import {
  FaShoppingCart,
  FaHeart
} from "react-icons/fa";

import { useShop } from "../context/ShopContext";

import "./Navbar.css";


function Navbar(){

const {favorites, cartCount}=useShop();

const [open,setOpen]=useState(false);



return(

<nav 
className="navbar"
onClick={()=>setOpen(false)}
>



<div className="logo">
CUTIES
</div>





<ul 
className={open ? "active" : ""}
onClick={(e)=>e.stopPropagation()}
>


<li onClick={()=>setOpen(false)}>
<Link to="/">
Home
</Link>
</li>



<li onClick={()=>setOpen(false)}>
<Link to="/shop">
Shop
</Link>
</li>



<li onClick={()=>setOpen(false)}>
<Link to="/contact">
Contact
</Link>
</li>


</ul>







<div className="right-area">



<div className="nav-icons">



<Link to="/favorites" className="icon">

<FaHeart/>

{favorites.length > 0 &&

<span className="cart-count">
{favorites.length}
</span>

}

</Link>





<Link to="/cart" className="icon">

<FaShoppingCart/>

{cartCount > 0 &&

<span className="cart-count">
{cartCount}
</span>

}

</Link>



</div>







<div 

className="menu-icon"

onClick={(e)=>{

e.stopPropagation();

setOpen(!open);

}}

>

☰

</div>





</div>





</nav>

);

}


export default Navbar;